// extracted by mini-css-extract-plugin
export default {"publishPointsList":"PublishCalibrationModals-PageHeader__publishPointsList--qHTSj"};